import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ImageUrl } from 'src/constants/imagesConst';

const CustomModal = ({ open, onClose }) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1200
        }}
        onClick={onClose} 
      />

    
      <Box
        sx={{
          width: '500px',
          padding: '30px',
          borderRadius: '12px',
          backgroundColor: '#fff',
          boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1300, 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <img
          src={ImageUrl.complaint}
          alt="No Access"
          style={{
            width: '100px',
            marginBottom: '20px'
          }}
        />

        <Typography
          variant="h2"
          sx={{
            color: '#1976D2',
            fontSize: '24px',
            marginBottom: '20px',
            fontWeight: 'bold'
          }}
        >
          {t('review.notificationTitle')}
        </Typography>

        <Typography
          sx={{
            fontSize: '18px',
            color: '#455a64',
            marginBottom: '30px'
          }}
        >
          {t('review.noAccessMessage')}
        </Typography>

        <Button
          onClick={onClose}
          sx={{
            backgroundColor: '#1976D2',
            color: 'white',
            padding: '12px 30px',
            borderRadius: '8px',
            fontSize: '18px',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
        >
          {t('review.closeButton')}
        </Button>
      </Box>
    </>
  );
};

export default CustomModal;
